<template>
    <div>
        <div v-for="(chart, idx) in charts" :key="idx" class="vx-col w-full mb-12">
            <div class="title">{{ chart.name }}</div>
            <vue-apex-charts height="300" :options="chart.chartOptions" :series="chart.chart.series"></vue-apex-charts>
        </div>
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

import dummyData from '../chart.json';

export default {
    data() {
        return {
            lists: [],
            charts: [],
        }
    },
    computed: {
        dummyData() {
            return dummyData
        },
    },
    components: {
        VueApexCharts
    },
    beforeMount() {
        this.lists = this.dummyData.data
    },
    mounted() {
        this.buildChartData()
    },
    methods: {
        buildChartData() {
            this.lists.map((x) => {
                const chart = {
                    ...x,
                    chartOptions: {
                        colors: ["#28C76F", "#EA5455", "#FF9F43", "#1E1E1E"],
                        plotOptions: {
                            bar: {
                                horizontal: false,
                                endingShape: "rounded",
                                columnWidth: "20%",
                            },
                        },
                        dataLabels: {
                            enabled: false,
                        },
                        stroke: {
                            show: true,
                            width: 2,
                            colors: ["transparent"],
                        },
                        chart: {
                            stacked: true,
                            type: "bar",
                            toolbar: { show: false },
                        },
                        xaxis: {
                            categories: x.chart.categories,
                        },
                        yaxis: {
                            title: {
                                text: "Unit",
                            },
                        },
                        fill: {
                            opacity: 1,
                        },
                        tooltip: {
                            y: {
                                formatter: function (val) {
                                    return Math.abs(val);
                                },
                            },
                        },
                    },
                }
                this.charts.push(chart);
            });
        },
    }
}
</script>